// This file was automatically generated from ptdata.lettersNew.html.
// Please don't edit this file by hand.

goog.provide('el8.template.ptdata.lettersNew');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.letters.attachments');
goog.require('el8.template.ptdata.patients');
goog.require('el8.template.render.reportFeedItem.referralDetail');
goog.require('el8.template.shared.commentReplyForm');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.lettersNew.signedSummaryNew = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FeedItemColMainTopLine"><a class="letter-toggle-collapse-trigger">', (opt_data.letter.isReferralLetter) ? ((el8Globals.FEATURES.BiDiLabs) ? (opt_data.letter.referralOrder.currentState == 'outstanding') ? '<div class="el8FeedItemNoticeText">Outstanding</div>' : (opt_data.letter.referralOrder.currentState == 'cancelled') ? '<span class="el8Strike el8999">' : '' : '') + 'Referral: ' : '', (opt_data.noHighlight) ? soy.$$escapeHtml(opt_data.letter.signUserName) : (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.letter.signUserName)) : soy.$$escapeHtml(opt_data.letter.signUserName)), ' <span class="el8LetterArrow"></span> ');
  el8.template.ptdata.lettersNew.recipientBase(opt_data, output);
  output.append('</a> ');
  el8.template.ptdata.lettersNew.recipientExtra(opt_data, output);
  output.append((el8Globals.FEATURES.BiDiLabs && opt_data.letter.isReferralLetter && opt_data.letter.referralOrder.currentState == 'cancelled') ? '</span>' : '', (opt_data.letter.isReferralLetter) ? ' <a class="el8FeedItemHeaderLinkNew ml10 item-details-trigger" data-id="' + soy.$$escapeHtml(opt_data.letter.referralOrder.id) + '">Open in Reports</a>' : '', ' <a class="el8FeedItemHeaderLinkNew ml10 letter-toggle-collapse-status letter-toggle-collapse-trigger">collapse status holder</a></div>', (el8Globals.FEATURES.BiDiLabs && opt_data.letter.isReferralLetter) ? (opt_data.letter.referralOrder.currentState == 'cancelled') ? '<div class="el8FeedColMainLine">Canceled on ' + (soy.$$escapeHtml(opt_data.letter.referralOrder.currentStateTime)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.letter.referralOrder.currentStateTime)) : '') + ((opt_data.letter.referralOrder.currentStateNote) ? ' &ndash; ' + soy.$$escapeHtml(opt_data.letter.referralOrder.currentStateNote) : '') + '</div>' : (opt_data.letter.referralOrder.currentState == 'fulfilled') ? '<div class="el8FeedColMainLine">Order fulfilled ' + ((opt_data.letter.referralOrder.currentStateNote) ? ' &ndash; ' + soy.$$escapeHtml(opt_data.letter.referralOrder.currentStateNote) : '') + '</div>' : '' : '', '<div class="el8FeedColMainLine">');
  el8.template.ptdata.lettersNew.letterStatus(opt_data.letter, output);
  output.append('</div><div class="el8FeedColMainLine el8SingleLineText">', (! (opt_data.letter.isReferralLetter || opt_data.letter.referralOrder)) ? (opt_data.letter.subject) ? '<span class="el8555">Re: ' + ((opt_data.noHighlight) ? soy.$$escapeHtml(opt_data.letter.subject) : (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.letter.subject)) : soy.$$escapeHtml(opt_data.letter.subject))) + '</span>' : '<span class="el8555">Re: (no subject)</span>' : '', (opt_data.letter.body) ? (opt_data.letter.isReferralLetter && opt_data.letter.referralOrder) ? ' <span class="letter-body-preview">Reason: ' + soy.$$escapeHtml(opt_data.letter.body) + '</span>' : ' <span class="letter-body-preview">' + ((opt_data.noHighlight) ? soy.$$escapeHtml(opt_data.letter.body) : (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.letter.body)) : soy.$$escapeHtml(opt_data.letter.body))) + '</span>' : '', '</div><div class="letter-collapsible-section ebs-form-horizontal">', (opt_data.letter.body) ? (opt_data.letter.isReferralLetter && opt_data.letter.referralOrder) ? '<div class="el8FieldSection ebs-form-group"><label class="el8FieldMedium ebs-control-label ebs-col-sm-2">Reason:</label><div class="el8FieldMediumLabelPadding el8Wrap el8StandardLineHeight el8StandardFontSize el8Preserve ebs-col-sm-10">' + soy.$$escapeHtml(opt_data.letter.body) + '</div></div>' : '<div class="el8FieldSection ebs-form-group"><p class="mt10 mb20 el8Preserve">' + ((opt_data.noHighlight) ? soy.$$escapeHtml(opt_data.letter.body) : (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.letter.body)) : soy.$$escapeHtml(opt_data.letter.body))) + '</p></div>' : '', '<div class="mb20">');
  if (opt_data.letter.isReferralLetter && opt_data.letter.referralOrder) {
    el8.template.render.reportFeedItem.referralDetail.contentReferralOrderDetail({authNumber: opt_data.letter.referralOrder.authNumber, authorizationFor: opt_data.letter.referralOrder.authorizationFor, icd9CodeObjs: opt_data.letter.referralOrder.icd9CodeObjs, icd10CodeObjs: opt_data.letter.referralOrder.icd10CodeObjs}, output);
  }
  output.append('</div>');
  if (opt_data.excludeAttachmentDetails) {
    output.append('<div class="padv5"><p class="el8AttachmentListChart el8GrayText">', soy.$$escapeHtml(opt_data.letter.attachments.length), ' attachment', (opt_data.letter.attachments.length != 1) ? 's' : '', ' (see chart for details)</p></div>');
  } else if (opt_data.letter.attachments.length) {
    output.append('<div class="el8FeedItemColMainSubHead">Attachments:</div>');
    el8.template.ptdata.lettersNew.attachmentSection(soy.$$augmentData(opt_data.letter, {noAttachmentLinks: opt_data.noAttachmentLinks}), output);
  }
  if (opt_data.letter.signedUnreadNotifications && opt_data.letter.signedUnreadNotifications.length || opt_data.letter.signedUnreadAlertDate) {
    output.append('<div class="letter-unread-notifications-section mt10 mb5"><div class="el8FeedItemColMainSubHead">Notifications:</div>');
    el8.template.ptdata.lettersNew.unreadNotifications({letter: opt_data.letter}, output);
    output.append('</div>');
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.lettersNew.reqActTitleUnsigned = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.letter.isReferralLetter) {
    output.append('Referral');
    if (opt_data.letter.displayTo) {
      output.append(' to ');
      el8.template.ptdata.lettersNew.recipient(soy.$$augmentData(opt_data, {noHighlight: true}), output);
    }
  } else {
    output.append('Letter');
    if (opt_data.letter.isSendToPatient || opt_data.letter.displayTo) {
      output.append(' to ');
      el8.template.ptdata.lettersNew.recipient(soy.$$augmentData(opt_data, {noHighlight: true}), output);
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.lettersNew.reqActSubjectUnsigned = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.letter.isReferralLetter) ? (opt_data.letter.body) ? ' Reason: ' + (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.letter.body)) : soy.$$escapeHtml(opt_data.letter.body)) : '' : 'Re: ' + ((opt_data.letter.subject) ? soy.$$escapeHtml(opt_data.letter.subject) : '(no subject)'));
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.lettersNew.feedIcon = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.isSendToPatient) ? '<div class="el8ChartFeedIconPtLetterOut"></div>' : (opt_data.isReferralLetter) ? '<div class="el8ChartFeedIconReferral"></div>' : '<div class="el8ChartFeedIconLetterOut"></div>', '<!--', (opt_data.viewedAt || opt_data.patientReadTime) ? '<div class="el8StatusIconSentOpened"></div>' : (opt_data.deliveryMethod == 'emr' || opt_data.deliveryMethod == 'passport' || opt_data.deliveryMethod == 'email') ? '<div class="el8StatusIconSentUnopened"></div>' : '', ' -->');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.lettersNew.letterMetadataCounts = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8CommentInfo">', (opt_data.comments.length) ? '<span class="el8IconComment"></span><span class="el8InlineBlock el8CommentData">' + soy.$$escapeHtml(opt_data.comments.length) + '</span>' : '', '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.lettersNew.secondarySection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.letter.isCommentsAllowed) {
    output.append('<div class="letter-responses-section mb10">');
    el8.template.ptdata.lettersNew.commentSection(soy.$$augmentData(opt_data.letter, {noHighlight: opt_data.noHighlight}), output);
    output.append('</div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.lettersNew.unreadNotifications = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.letter.signedUnreadAlertDate) ? '<div class="el8StandardFontSize"><span class="el8NotificationIcon"></span>To be notified if not opened by ' + (soy.$$escapeHtml(opt_data.letter.signedUnreadAlertDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.letter.signedUnreadAlertDate)) : '') + '</div>' : '');
  if (opt_data.letter.signedUnreadNotifications && opt_data.letter.signedUnreadNotifications.length) {
    var summaryList19780 = opt_data.letter.signedUnreadNotifications;
    var summaryListLen19780 = summaryList19780.length;
    for (var summaryIndex19780 = 0; summaryIndex19780 < summaryListLen19780; summaryIndex19780++) {
      var summaryData19780 = summaryList19780[summaryIndex19780];
      output.append('<div class="el8StandardFontSize el8999">', soy.$$escapeHtml(summaryData19780), '</div>');
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.lettersNew.commentControls = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.comments.length) {
    output.append('<div class="comment-count el8FeedItemColMainSubHead">');
    el8.template.ptdata.lettersNew.commentCount(opt_data, output);
    output.append('</div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.lettersNew.commentSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.isCommentsAllowed) {
    el8.template.ptdata.lettersNew.commentControls(opt_data, output);
    output.append('<div class="el8MessageWrapper letter-comments"><ul class="el8ResponsesWrap ebs-list-unstyled">');
    var cList19796 = opt_data.comments;
    var cListLen19796 = cList19796.length;
    for (var cIndex19796 = 0; cIndex19796 < cListLen19796; cIndex19796++) {
      var cData19796 = cList19796[cIndex19796];
      el8.template.ptdata.lettersNew.comment(soy.$$augmentData(cData19796, {patientId: opt_data.patientId, noHighlight: opt_data.noHighlight}), output);
    }
    el8.template.shared.commentReplyForm.replyTrigger(opt_data, output);
    output.append('</ul></div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.lettersNew.recipientBase = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.letter.isSendToPatient) {
    el8.template.ptdata.patients.displayName(opt_data.patient, output);
  } else {
    output.append((opt_data.noHighlight) ? soy.$$escapeHtml(opt_data.letter.displayTo) : (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.letter.displayTo)) : soy.$$escapeHtml(opt_data.letter.displayTo)), (opt_data.letter.isReferralLetter && opt_data.letter.referralOrder.specialtyName) ? ' (' + soy.$$escapeHtml(opt_data.letter.referralOrder.specialtyName) + ')' : '', (opt_data.letter.deliveryMethod == 'emr') ? '<span class="el8InlineElationMarkNew"></span>' : (opt_data.letter.deliveryMethod == 'passport') ? '<span class="el8InlinePassportMark"></span>' : '');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.lettersNew.recipientExtra = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.letter.deliveryMethod == 'direct') ? ' <span class="el8FontSmall el8999">d: ' + soy.$$escapeHtml(opt_data.letter.directMessageTo) + '</span>' : (opt_data.letter.deliveryMethod == 'email') ? ' <span class="el8FontSmall el8999">e: ' + soy.$$escapeHtml(opt_data.letter.emailTo) + '</span>' : (opt_data.letter.deliveryMethod == 'fax' && opt_data.letter.sendToContactId) ? ' <span class="el8FontSmall el8999">f: ' + soy.$$escapeHtml(opt_data.letter.toNumber) + '</span>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.lettersNew.recipient = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.ptdata.lettersNew.recipientBase(opt_data, output);
  el8.template.ptdata.lettersNew.recipientExtra(opt_data, output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.lettersNew.letterStatus = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.isPostDated) {
    output.append('<span class="el8LetterStatusNew el8LetterUnopened">To be delivered on ', (soy.$$escapeHtml(opt_data.deliveryDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.deliveryDate)) : ''), '</span>');
  } else if (opt_data.deliveryMethod == 'printed') {
  } else if (opt_data.deliveryMethod == 'direct') {
    el8.template.ptdata.lettersNew.directMessageStatus(opt_data, output);
    if (opt_data.faxStatus) {
      el8.template.ptdata.lettersNew.faxStatus(opt_data, output);
    }
  } else if (opt_data.deliveryMethod == 'fax' || opt_data.deliveryMethod == 'passport' && ! opt_data.isSendToPatient) {
    if (opt_data.viewedAt) {
      el8.template.ptdata.lettersNew.openedStatus(opt_data, output);
    } else if (opt_data.isFaxAttachments || opt_data.faxStatus && opt_data.faxStatus != 'success') {
      el8.template.ptdata.lettersNew.faxStatus(opt_data, output);
    } else {
      el8.template.ptdata.lettersNew.openedStatus(opt_data, output);
    }
  } else {
    el8.template.ptdata.lettersNew.openedStatus(opt_data, output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.lettersNew.openedStatus = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.isSendToPatient || opt_data.deliveryMethod == 'emr' || opt_data.deliveryMethod == 'email') {
    output.append((opt_data.patientReadTime) ? '<span class="el8LetterStatusNew el8LetterOpened">Opened on ' + (soy.$$escapeHtml(opt_data.patientReadTime)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.patientReadTime)) : '') + '</span>' : (opt_data.viewedAt) ? '<span class="el8LetterStatusNew el8LetterOpened">Opened on ' + (soy.$$escapeHtml(opt_data.viewedAt)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.viewedAt)) : '') + '</span>' : '<span class="el8LetterStatusNew el8LetterUnopened"><span class="el8Medium">Unopened</span>,  sent on ' + ((opt_data.deliveryDate) ? (soy.$$escapeHtml(opt_data.deliveryDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.deliveryDate)) : '') : (soy.$$escapeHtml(opt_data.signDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.signDate)) : '')) + '</span>');
  } else {
    if (opt_data.viewedAt) {
      output.append('<span class="el8LetterStatusNew el8LetterOpened">Opened on ', (soy.$$escapeHtml(opt_data.viewedAt)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.viewedAt)) : ''), '</span>');
    } else if (opt_data.faxStatus == 'failed') {
      el8.template.ptdata.lettersNew.faxStatus(opt_data, output);
    } else {
      output.append('<span class="el8LetterStatusNew el8LetterUnopened">Sent on ', (opt_data.faxCompleteTime) ? (soy.$$escapeHtml(opt_data.faxCompleteTime)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.faxCompleteTime)) : '') : (opt_data.faxedAt) ? (soy.$$escapeHtml(opt_data.faxedAt)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.faxedAt)) : '') : (opt_data.deliveryDate) ? (soy.$$escapeHtml(opt_data.deliveryDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.deliveryDate)) : '') : (soy.$$escapeHtml(opt_data.signDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.signDate)) : ''), '  (attachments unopened)</span>');
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.lettersNew.faxStatus = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.faxStatus == 'success' && opt_data.faxedAt) ? '<span class="el8LetterStatusNew el8LetterOpened">Fax sent on ' + ((opt_data.faxCompleteTime) ? (soy.$$escapeHtml(opt_data.faxCompleteTime)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.faxCompleteTime)) : '') : (soy.$$escapeHtml(opt_data.faxedAt)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.faxedAt)) : '')) + '</span>' : (opt_data.faxStatus == 'failed') ? (opt_data.faxErrorShortMessage) ? '<span class="el8LetterStatusNew el8LetterFailed el8Bold" style="border-radius: 4px">Fax Failed: ' + soy.$$escapeHtml(opt_data.faxErrorShortMessage) + '</span>' + ((opt_data.faxErrorLongMessage) ? '<div style="background-color: #DBEBFF; border-radius: 4px; padding: 3px; margin-top: 11px; margin-bottom: 11px"><div class="fax-error-long-message-collapse-trigger" style="cursor: pointer;color: #07479D"><span class="fax-error-long-message-collapse-status el8LeftArrowIcon"></span> Tell Me More</div><div class="fax-error-collapsible-section pad15" style="color: #253A40">' + ((opt_data.faxId && ! opt_data.letterId) ? '<p class="el8AppText">' + soy.$$escapeHtml(opt_data.faxErrorLongMessage) + '</p><p class="el8AppText el8Spacer">Please copy and paste the following into your support request:</p><p class="el8AppText">Failed Fax</p>' : '<p class="el8AppText mb10">Please copy and paste the following into your support request:</p><p class="el8AppText">Failed Fax: Internal Error</p>') + ((opt_data.showFaxErrorDetails) ? '<ul class="el8StandardList el8AppText"><li class="el8StandardFontSize" style="display: list-item;">Patient ID: ' + soy.$$escapeHtml(opt_data.patientId) + '</li><li class="el8StandardFontSize" style="display: list-item;">Date of Fax Failure: ' + (soy.$$escapeHtml(opt_data.faxedAt)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.faxedAt)) : '') + '</li><li class="el8StandardFontSize" style="display: list-item;">Fax Recipient Number: ' + (soy.$$escapeHtml(opt_data.faxTo)? el8.util.string.formatPhoneNum(soy.$$escapeHtml(opt_data.faxTo)) : '') + '</li>' + ((opt_data.faxId) ? '<li class="el8StandardFontSize" style="display: list-item;">Fax ID: ' + soy.$$escapeHtml(opt_data.faxId) + '</li>' : '') + ((opt_data.letterId) ? '<li class="el8StandardFontSize" style="display: list-item;">Letter ID: ' + soy.$$escapeHtml(opt_data.letterId) + '</li>' : '') + '</ul>' : '') + '</div></div>' : '') : '<span class="el8LetterStatusNew el8LetterFailed el8Bold" style="border-radius: 4px">Fax Failed</span>' : (opt_data.faxStatus == 'pending') ? '<span class="el8LetterStatusNew el8LetterUnopened"><span class="el8Medium">Fax Pending</span></span>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.lettersNew.directMessageStatus = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.directMessageStatus == 'complete' && opt_data.directMessageSentOn) ? '<span class="el8LetterStatusNew el8LetterOpened">Direct Message Sent on ' + (soy.$$escapeHtml(opt_data.directMessageSentOn)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.directMessageSentOn)) : '') + '</span>' : (opt_data.directMessageStatus == 'error' || opt_data.directMessageStatus == 'failure') ? '<span class="el8LetterStatusNew el8LetterFailed el8Bold">Direct Message Failed to Send</span>' : (opt_data.directMessageStatus == 'pending_complete') ? '<span class="el8LetterStatusNew el8LetterUnopened"><span class="el8Medium">Direct Message Pending</span></span>' : '<span class="el8LetterStatusNew el8LetterUnopened"><span class="el8Medium">Direct Message Is Being Sent</span></span>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.lettersNew.reminderBody = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.isSendToPatient) ? 'Hi, I would like to follow-up on my last message, since I have not received a response from you yet. Thank you.' : 'Hi, I would like to follow-up on the care for this patient. I have not received a response from your practice yet. Please let me know when you will be seeing the patient. Thank you.');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.lettersNew.attachmentSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<ol class="padv5 ebs-list-unstyled">');
  var aList19989 = opt_data.attachments;
  var aListLen19989 = aList19989.length;
  for (var aIndex19989 = 0; aIndex19989 < aListLen19989; aIndex19989++) {
    var aData19989 = aList19989[aIndex19989];
    output.append('<li class="el8AttachmentListChart el8StandardFontSize"><img class="el8PaperClip fl ebs-pull-left" src="/static/images/transparent_16x16.png"> ');
    el8.template.ptdata.letters.attachments.savedAttachmentSummary(soy.$$augmentData(aData19989, {noAttachmentLinks: opt_data.noAttachmentLinks, noHighlight: opt_data.noHighlight}), output);
    output.append('</li>');
  }
  output.append('</ol>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.lettersNew.comment = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8MessageContent clearfix"><div class="el8MsgAvatar">', (opt_data.authorStaffType == 'Patient') ? '<img src="/patient/' + soy.$$escapeHtml(opt_data.patientId) + '/photo/profile/24/24/" />' : '<img src="/user/' + soy.$$escapeHtml(opt_data.authorId) + '/photo/profile/24/24/" />', '</div>', (opt_data.fromPracticeId != el8Globals.PRACTICE_ID && ! opt_data.readTime) ? '<span class="el8MessageNewMarker"></span>' : '', '<div class="el8MessageMetaData"><span class="el8MessageAuthor', (opt_data.authorStaffType == 'Patient') ? ' el8PatientText' : (opt_data.authorStaffType == 'OfficeStaff') ? ' el8StaffTextNew' : (opt_data.authorStaffType == 'Physician') ? ' el8PhysicianText' : '', '">', (opt_data.noHighlight) ? soy.$$escapeHtml(opt_data.authorName) : (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.authorName)) : soy.$$escapeHtml(opt_data.authorName)), '</span><span class="el8MessageTimeStamp">', (soy.$$escapeHtml(opt_data.createDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.createDate)) : ''), ' at ', (soy.$$escapeHtml(opt_data.createDate)? el8.service.tz.soyTime(soy.$$escapeHtml(opt_data.createDate)) : ''), '</span></div><div class="el8MessageText"><span class="el8Preserve', (opt_data.authorStaffType == 'Patient') ? ' el8PatientText' : (opt_data.authorStaffType == 'OfficeStaff') ? ' el8StaffTextNew' : (opt_data.authorStaffType == 'Physician') ? ' el8PhysicianText' : '', '">', (opt_data.noHighlight) ? soy.$$escapeHtml(opt_data.message) : (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.message)) : soy.$$escapeHtml(opt_data.message)), '</span>', (opt_data.readTime && opt_data.readUserName) ? '<span class="el8MessageOpened">Opened on ' + (soy.$$escapeHtml(opt_data.readTime)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.readTime)) : '') + ' at ' + (soy.$$escapeHtml(opt_data.readTime)? el8.service.tz.soyTime(soy.$$escapeHtml(opt_data.readTime)) : '') + ' by ' + soy.$$escapeHtml(opt_data.readUserName) + '.</span>' : '', '</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.lettersNew.commentCount = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append(soy.$$escapeHtml(opt_data.comments.length), ' Response', (opt_data.comments.length > 1) ? 's' : '', ':');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.lettersNew.noteSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('Letter to', (opt_data.isSendToPatient) ? ' patient' : ' ' + soy.$$escapeHtml(opt_data.displayTo), (opt_data.subject) ? ' re: ' + soy.$$escapeHtml(opt_data.subject) : '', ' ');
  switch (opt_data.deliveryMethod) {
    case 'printed':
      output.append('printed');
      break;
    case 'emr':
      output.append('sent to EMR');
      break;
    case 'passport':
      output.append('sent to Passport');
      break;
    case 'fax':
      output.append('faxed');
      break;
    case 'email':
      output.append('emailed');
      break;
  }
  output.append(' on ', (soy.$$escapeHtml(opt_data.documentDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.documentDate)) : ''));
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.lettersNew.commentQtip = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.count == 1) ? 'There is ' + soy.$$escapeHtml(opt_data.count) + ' response' : 'There are ' + soy.$$escapeHtml(opt_data.count) + ' responses', ' to this letter');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.lettersNew.notesQtip = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.count == 1) ? 'There is ' + soy.$$escapeHtml(opt_data.count) + ' internal note' : 'There are ' + soy.$$escapeHtml(opt_data.count) + ' internal notes', ' on this letter');
  if (!opt_sb) return output.toString();
};
